export enum CreatedByType {
	ME = 'ME',
	USER = 'USER',
	WORKPLACE = 'WORKPLACE',
}
